/* eslint-disable */
import { Translations } from '../../services';

const translations = {
  state: {
    translations: {}
  },
  getters: {
    i18n: (state) => (key, ...arg) => {
      let index = 0;
      const keyName = key.split(' ').join('_');
      const translation = state.translations[keyName];
      if (translation) {
        return translation.replace(/(%[a-zA-Z_-]*%)/gm, () => arg[index++]);
      } else {
        return keyName;
      }
    }
  },
  mutations: {
    SET_TRANSLATIONS: (state, payload) => {
      state.translations = payload;
    },
  },
  actions: {
    GET_TRANSLATIONS: ({ commit, rootState }) => {
      return Translations.get(rootState.lang)
        .then(response => {
          commit('SET_TRANSLATIONS', response);
        });
    },
  },
}

export default translations;



// WEBPACK FOOTER //
// ./src/store/modules/translations.js